import type { PropsWithChildren } from 'react';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

export interface LayoutContainerProps extends PropsWithChildren {
  gap: number;
}

export const LayoutContainer = forwardRef<HTMLDivElement, LayoutContainerProps>(
  ({ children, gap, ...forwardingProps }, forwardingRef) => {
    return (
      <Container
        ref={forwardingRef}
        _offset={gap <= 20 ? 20 : 40}
        {...forwardingProps}
      >
        {children}
      </Container>
    );
  }
);

const Container = styled.div<{ _offset: number }>`
  ${({ _offset }) => css`
    margin: ${_offset}px 0;
  `}
`;
